import { QueryClient } from '@tanstack/react-query';
import { createRouter } from '@tanstack/react-router';
import { setupRouterSsrQueryIntegration } from '@tanstack/react-router-ssr-query';

import type { RouterContext } from './router-context.ts';
import { routeTree } from './routeTree.gen.ts';

function createQueryClient(): QueryClient {
	return new QueryClient({
		defaultOptions: {
			queries: {
				gcTime: 30 * 60 * 1000,
				refetchOnReconnect: false,
				refetchOnWindowFocus: false,
				retry: false,
				staleTime: 5 * 60 * 1000,
			},
		},
	});
}

export function getRouter() {
	const queryClient = createQueryClient();
	const router = createRouter({
		context: {
			authSession: null,
			queryClient,
		} satisfies RouterContext,
		defaultPreload: 'intent',
		defaultPreloadStaleTime: 0,
		routeTree,
		scrollRestoration: true,
	});

	setupRouterSsrQueryIntegration({
		queryClient,
		router,
	});

	return router;
}

declare module '@tanstack/react-router' {
	interface Register {
		router: ReturnType<typeof getRouter>;
	}
}
